import { useId } from 'react';

export interface ToggleProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  labelHidden?: boolean;
  /** Explains why the control is locked, e.g. commission accrual set at invite. */
  title?: string;
}

/**
 * A real checkbox, visually replaced. The prototype used styled spans with click
 * handlers, which are invisible to keyboards and screen readers.
 */
export function Toggle({ label, checked, onChange, disabled, labelHidden, title }: ToggleProps) {
  const id = useId();
  return (
    <label className="toggle" htmlFor={id} title={title}>
      <input
        id={id}
        type="checkbox"
        className="toggleInput"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.currentTarget.checked)}
      />
      <span className="toggleTrack" aria-hidden="true">
        <span className="toggleThumb" />
      </span>
      <span className={labelHidden ? 'visuallyHidden' : 'typeMetaStrong'}>{label}</span>
    </label>
  );
}
